import React, { useEffect, useState } from "react";
import { Input } from "reactstrap";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Handler from "../Helpers/Handler";

const BASE = "https://qnexus.in/community/";
// const BASE = "http://localhost/business_community/";
const FALLBACK = "https://ui-avatars.com/api/?name=";

const QnexusHeader = ({ onMenuClick }) => {  // 👈 ADDED PROP

  const user = useSelector(s => s.customer?.customer?.user);
  const [unreadCount, setUnreadCount] = useState(0);

  const fetchUnreadCount = async () => {
    try {
      const r = await Handler({ method: "get", url: "/notification/list.php" });
      if (r?.success) {
        const unread = (r.data.list || []).filter(n => !n.is_read).length;
        setUnreadCount(unread);
      }
    } catch (e) { }
  };

  useEffect(() => {
    fetchUnreadCount();
    window.addEventListener("focus", fetchUnreadCount);
    return () => window.removeEventListener("focus", fetchUnreadCount);
  }, []);

  return (
    <div className="qnexus-header">

      {/* ✅ ADDED: Mobile Menu Button (no removal of existing content) */}
      <button className="menu-toggle d-lg-none me-2" onClick={onMenuClick}>
        <i className="bx bx-menu fs-3"></i>
      </button>

      <div className="header-right ms-auto">

        <div className="header-icon position-relative">
          <Link to="/user/notifications">
            <i className='fs-3 bx bx-bell'></i>
          </Link>

          {unreadCount > 0 && (
            <span
              style={{
                position: "absolute",
                top: -5,
                right: -5,
                background: "red",
                color: "#fff",
                borderRadius: "50%",
                padding: "2px 6px",
                fontSize: 11,
                fontWeight: 600
              }}
            >
              {unreadCount}
            </span>
          )}
        </div>

        <div className="header-profile">
          <img
            src={user?.logo ? BASE + user.logo : `${FALLBACK}+${user?.name || "U"}`}
            alt="user"
          />
          <div>
            <h6 className="text-capitalize">{user?.name || "User"}</h6>
            <span>{user?.email || "user@email.com"}</span>
          </div>
        </div>

      </div>
    </div>
  );
};

export default QnexusHeader;
